import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Observable } from "rxjs";
import { ICollection } from "@gtmhub/models";
import NavigationItemsMediator from "@webapp/navigation/services/uxcustomization/navigation-items.mediator.service";
import { getNavItemsType } from "@webapp/navigation/utils/nav-items.util";
import { INavItem, NavItemsGroupType, NavItemsType } from "../../../../models/nav-items-list.models";

@Component({
  selector: "gh-home-sub-navigation",
  templateUrl: "./home-sub-navigation.component.html",
})
export class HomeSubNavigationComponent implements OnInit {
  @Output() private titleChange = new EventEmitter<string>();
  public sessions$: Observable<ICollection<INavItem>>;
  public goals$: Observable<ICollection<INavItem>>;
  public kpis$: Observable<ICollection<INavItem>>;
  public whiteboards$: Observable<ICollection<INavItem>>;
  public tasks$: Observable<ICollection<INavItem>>;
  public lists$: Observable<ICollection<INavItem>>;
  public insightboards$: Observable<ICollection<INavItem>>;
  public people$: Observable<ICollection<INavItem>>;
  public loading$: Observable<boolean>;
  public visibleItemsCount = 3;
  public indicators: { loading?: boolean } = {};
  public itemsGroupType = "favorites" as NavItemsGroupType;
  private sectionTitle = "Home";

  public constructor(protected navigationItemsMediator: NavigationItemsMediator) {}

  public ngOnInit(): void {
    this.titleChange.emit(this.sectionTitle);

    ["sessions", "okrs", "kpis", "tasks", "whiteboards", "lists", "insightboards", "people"].forEach((navItemsType: NavItemsType) => {
      this.navigationItemsMediator.loadFavorites(navItemsType);
    });

    this.sessions$ = this.navigationItemsMediator.getFavoritesItems$("sessions");
    this.goals$ = this.navigationItemsMediator.getFavoritesItems$("okrs");
    this.lists$ = this.navigationItemsMediator.getFavoritesItems$("lists");
    this.whiteboards$ = this.navigationItemsMediator.getFavoritesItems$("whiteboards");
    this.tasks$ = this.navigationItemsMediator.getFavoritesItems$("tasks");
    this.kpis$ = this.navigationItemsMediator.getFavoritesItems$("kpis");
    this.insightboards$ = this.navigationItemsMediator.getFavoritesItems$("insightboards");
    this.people$ = this.navigationItemsMediator.getFavoritesItems$("people");
  }

  public onUnmarkItemAsFavorite(item: INavItem): void {
    const navItemsType: NavItemsType | undefined = getNavItemsType(item.uxcType);
    if (navItemsType !== undefined) {
      this.navigationItemsMediator.unmarkItemAsFavorite(item.favoriteId, item.uxcType, item, navItemsType);
    }
  }
}
